import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBookOpen } = FiIcons;

const ResumeEducation = ({ education }) => {
  return (
    <section>
      <h3 className="text-lg font-bold text-slate-900 uppercase tracking-wider border-b-2 border-slate-200 pb-2 mb-4">
        Education
      </h3>
      <div className="flex items-start gap-3">
        <div className="bg-slate-100 p-3 rounded-lg">
          <SafeIcon icon={FiBookOpen} className="text-slate-600 text-xl" />
        </div>
        <div>
          <h4 className="font-bold text-slate-800 text-lg">{education.degree}</h4>
          <div className="text-md text-slate-600 font-medium">
            {education.school}
          </div>
          <div className="text-sm text-slate-500">
            {education.location}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResumeEducation;